import { llpaTypeApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LLPA_TYPES_ACTION_TYPE = createNamedActions('llpaTypes', {
  GET_LLPA_TYPES: 'GET_LLPA_TYPES',
  CREATE_LLPA_TYPES: 'CREATE_LLPA_TYPES',
  EDIT_LLPA_TYPES: 'EDIT_LLPA_TYPES',
  DELETE_LLPA_TYPES: 'DELETE_LLPA_TYPES',
  ENABLE_LLPA_TYPES: 'ENABLE_LLPA_TYPES',
});

const llpaTypesSchema = new schema.Entity('data', {}, { idAttribute: 'llpaTypeId' });

export const getLLPATypesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await llpaTypeApi.getTypes();

  return dispatch({
    type: LLPA_TYPES_ACTION_TYPE.GET_LLPA_TYPES,
    payload: normalize(data, [llpaTypesSchema]).entities.data,
  });
});

export const createLLPATypesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await llpaTypeApi.createType(params);

  return dispatch({
    type: LLPA_TYPES_ACTION_TYPE.CREATE_LLPA_TYPES,
    payload: data,
  });
});

export const editLLPATypesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await llpaTypeApi.editType(params);

  return dispatch({
    type: LLPA_TYPES_ACTION_TYPE.EDIT_LLPA_TYPES,
    payload: data,
  });
});

export const deleteLLPATypesAction = catchAsyncActionError(({ llpaTypeId }) => async dispatch => {
  await llpaTypeApi.deleteType({ llpaTypeId });

  return dispatch({
    type: LLPA_TYPES_ACTION_TYPE.DELETE_LLPA_TYPES,
    meta: { llpaTypeId },
  });
});

export const enableLLPATypesAction = catchAsyncActionError(({ llpaTypeId }) => async dispatch => {
  await llpaTypeApi.activateType({ llpaTypeId });

  return dispatch({
    type: LLPA_TYPES_ACTION_TYPE.ENABLE_LLPA_TYPES,
    meta: { llpaTypeId },
  });
});
